const state = {
    token: null,
    isAuthenticated: false,
    error: null
  }
  
  const getters = {
    getToken: state => state.token,
    isAuthenticated: state => state.isAuthenticated,
    getError: state => state.error
  }
  
  const mutations = {
    setToken(state, token) {
      state.token = token
    },
    setIsAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setError(state, error) {
      state.error = error
    }
  }
  
  const actions = {
    async eudoApiAuth({ commit }) {
      try {
        const response = await this.$axios.api.post("auth/eudoapi")
        if (response.status == 200) {
          commit("setIsAuthenticated", true)
        } else {
          commit("setError", response.data.message)
          commit("setIsAuthenticated", false)
        }
      } catch (err) {
        commit("setError", err.response.data.message)
        commit("setIsAuthenticated", false)
      }
    },
    async eudonetSpecifAuth({ commit }) {
      try {
        const response = await this.$axios.api.post("auth/specif-short")
        if (response.status == 200) {
          commit("setIsAuthenticated", true)
        } else {
          commit("setError", response.data.message)
          commit("setIsAuthenticated", false)
        }
      } catch (err) {
        console.log("eudonetSpecifAuth->err")
        console.log(err)
        commit("setError", err.response.data.message)
        commit("setIsAuthenticated", false)
      }
    }
  }
  
  export const authStore = {
    strict: true,
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  